module.exports = __webpack_public_path__ + "static/physical-mental-health-body-1-4949a41d68540c8e5fe60723105075bb.jpg";